<template>
    <!-- Gönderilmiş ve kapanmamış fatura → tıklanabilir ödeme linki butonu (yeni sekme) -->
    <a v-if="showLink"
       :href="'/Payment/'+row.GroupCode"
       target="_blank"
       rel="noopener"
       class="btn btn-icon btn-sm btn-flat-primary"
       v-b-tooltip.noninteractive.hover.bottom
       title="Ödeme linkini yeni sekmede aç">
        <feather-icon icon="ExternalLinkIcon"></feather-icon>
    </a>
    <!-- Zaman aşımı → buton yok, sadece bilgi (kırmızı kum saati) -->
    <span v-else-if="isTimedOut"
          class="text-danger d-inline-flex align-items-center"
          v-b-tooltip.noninteractive.hover.bottom
          title="Ödeme linki zaman aşımına uğradı">
        <span class="material-icons-round v-paylink-timeout-icon">hourglass_disabled</span>
    </span>
    <span v-else class="text-muted">-</span>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue'

// Backend: Domain/BaseDb/Enums/PaymentPoolStatus.cs
// Ödeme sayfası (GetPaymentPoolDataByGroupCode) bir linki yalnızca
// SentToCustomer (3) veya PartiallyPaid (5) iken canlı/ödenebilir kabul eder.
const STATUS_SENT_TO_CUSTOMER = 3
const STATUS_PARTIALLY_PAID = 5
const STATUS_TIMEOUT = [2, 4] // Yönetici / müşteri kaynaklı zaman aşımı

export default {
    directives:{ 'b-tooltip':VBTooltip },
    props:{
        fields:[String,Number],
        row:Object
    },
    computed:{
        status(){
            const raw = this.row?.PaymentPoolStatus
            if(raw === null || raw === undefined || raw === '') return null
            return Number(raw)
        },
        isClosed(){
            // Yalnızca tamamen kapanmış (kalan borç kalmamış) fatura
            return !(Number(this.row?.KalanBorc) > 0)
        },
        isLiveSent(){
            // Müşteriye gönderilmiş ve hâlâ ödenebilir link
            if(this.status === STATUS_SENT_TO_CUSTOMER) return true
            // Parçalı ödenmiş ve son ödeme tarihi geçmemiş → link hâlâ canlı
            if(this.status === STATUS_PARTIALLY_PAID) return !this.row?.IsPartialAndLastInvoiceDatePassed
            return false
        },
        isTimedOut(){
            return STATUS_TIMEOUT.includes(this.status)
        },
        showLink(){
            // Canlı/gönderilmiş ve tamamen kapanmamış faturaların linki tıklanabilir olsun
            return this.isLiveSent && !this.isClosed && !!this.row?.GroupCode
        }
    }
}
</script>

<style>
.v-paylink-timeout-icon{
    font-size: 1.1rem;
}
</style>
